import type { FaireProductEntity } from "../../entity_types/product";

export const p_3rkwc6f64v: FaireProductEntity = {
  token: "p_3rkwc6f64v",
  type: "product",
  name: "ID8967  STRIPED LONG BACK TIE STRAPLESS MAXI DRESS",
  brandToken: "b_7435km15nr",
  brandName: "Klesis",
  imageUrl:
    "https://cdn.faire.com/fastly/3af53245001c03c6d56031b673364bf0b6fcd1b0c6254158c1318b2fab975d6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3a54b82558e1011e873949dbff0014bd6bbcd1ac815f98513e0ad80e3088f4a.jpeg",
    "https://cdn.faire.com/fastly/9aee9272d443f3697a22e9a9dcf34b5430e4ab38c65c3f6c0c409c662a9739e0.jpeg",
    "https://cdn.faire.com/fastly/a99df53bd3c7c6181f093c9916f25848600905610b7a4a5bbb83a5b1a454149b.jpeg",
    "https://cdn.faire.com/fastly/b1309ea8fc994696ac3a86c1c8131a4017e99e908c344dd2a65590b8b0627657.jpeg",
    "https://cdn.faire.com/fastly/0a0023e9aa06a0e39cda6630d17056f870957d2c9503a3670b757fe96a37320e.jpeg",
    "https://cdn.faire.com/fastly/43d51ee9e2bb2b74138ded64a3a18cfbfb3a1ccfa08cce3cdf4b4c0a40e60f29.jpeg",
    "https://cdn.faire.com/fastly/0d036a64667c62a2354eb88863572f051c58310d8814683e59b3ca60e3e94a11.jpeg",
    "https://cdn.faire.com/fastly/287f714c7b3d13c5e0f9b37dc34d75af480903fa877106a34cbd51cb7bb11f54.jpeg",
    "https://cdn.faire.com/fastly/b11501b0300e6a4d6829baae640222ed4cd1d96f81a3422af808c87955a039d5.jpeg",
    "https://cdn.faire.com/fastly/29bb73b4e617ab3efda4b383dfe3c16eaddc3ad99bd6a4decd5f2fd22d558b37.jpeg",
  ],
  priceDollars: 192,
  description:
    "Striped Long and Lean Back Tie Strapless Maxi Dress\n\n70% Rayon 30% Linen",
  tags: [],
  msrpDollars: 384,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:48.024Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
